/**
 * フラグメント検出とリダイレクト処理を担当するスクリプト
 * メンテナンスモード時のフラグメント処理を一元管理
 */
function initFragmentRedirect() {
  // メンテナンスモードフラグがない場合は何もしない
  if (typeof window.isMaintenanceMode === 'undefined') {
    console.log('メンテナンスモード情報が見つかりません');
    return;
  }

  // メンテナンスモードでない場合は何もしない
  if (!window.isMaintenanceMode) {
    return;
  }

  // 現在のURLと状態を取得
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;
  
  // アカウントログインページでrecoverフラグメントを検出した場合
  if (currentPath === '/account/login' && (currentHash === '#recover' || currentHash !== '')) {
    // リカバリーフォームを即座に非表示
    hideRecoverForm();
    
    // メンテナンスページにリダイレクト
    redirectToMaintenance();
    return;
  }
  
  // URLフラグメント変更の監視
  window.addEventListener('hashchange', function() {
    const newHash = window.location.hash;
    
    // アカウントログインページでrecoverフラグメントを検出した場合
    if (currentPath === '/account/login' && (newHash === '#recover' || newHash !== '')) {
      // リカバリーフォームを即座に非表示
      hideRecoverForm();
      
      // メンテナンスページにリダイレクト
      redirectToMaintenance();
    }
  });
  
  // パスワード忘れリンクのイベントリスナーを設定
  const recoverLink = document.querySelector('[account_pw_recover]');
  if (recoverLink) {
    recoverLink.addEventListener('click', function(e) {
      if (currentPath === '/account/login') {
        // デフォルトの動作を防止
        e.preventDefault();
        
        // リカバリーフォームを即座に非表示
        hideRecoverForm();
        
        // メンテナンスページにリダイレクト
        redirectToMaintenance();
        return false;
      }
    });
  }
}

// リカバリーフォームを非表示にする関数
function hideRecoverForm() {
  const recoverForm = document.getElementById('recover');
  if (recoverForm) {
    recoverForm.style.display = 'none';
    recoverForm.style.visibility = 'hidden';
    recoverForm.style.opacity = '0';
  }
}

// メンテナンスページにリダイレクトする関数
function redirectToMaintenance() {
  window.location.href = '/pages/maintenance';
}

// DOMが読み込まれた後に初期化
document.addEventListener('DOMContentLoaded', initFragmentRedirect);
